import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/layouts/default.vue").then(m => m.default || m)),
  home: defineAsyncComponent(() => import("/home/atlassian-bitbucket-pipelines-runner/temp/97879403-67f4-514c-a45d-2e956d33a186/build/layouts/home.vue").then(m => m.default || m))
}